import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const biz = localStorage.getItem("business_id");
  if (biz) config.headers["X-Business-Id"] = biz;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("token");
      if (!window.location.pathname.startsWith("/player")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const mediaUrl = (mediaId) => `${API}/media/${mediaId}/file`;

// Chunked upload for large finished videos. Streams the file in small parts so it
// slips under the ingress body-size limit and reports real byte-level progress.
export async function uploadFileChunked(file, onProgress) {
  const { data: init } = await api.post("/media/upload/init", {
    filename: file.name, content_type: file.type || "", size: file.size,
  });
  const uploadId = init.upload_id;
  const chunkSize = init.chunk_size || 5 * 1024 * 1024;
  const total = Math.max(1, Math.ceil(file.size / chunkSize));
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunkSize, (i + 1) * chunkSize);
    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("index", String(i));
    fd.append("chunk", blob, "chunk");
    await api.post("/media/upload/chunk", fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 });
    if (onProgress) onProgress(Math.min(95, Math.round(((i + 1) / total) * 95)));
  }
  const { data: doc } = await api.post("/media/upload/complete", { upload_id: uploadId }, { timeout: 180000 });
  if (onProgress) onProgress(100);
  return doc;
}

export default api;
